import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Checkbox as PaperCheckbox } from 'react-native-paper';
import { Colors } from '../constants/Colors';
import { TextReg } from './StyledText';

type CheckboxGroupOption = {
  label: string;
  value: string;
};

type Props = {
  options: CheckboxGroupOption[];
  selectedValues: string[];
  onValueChange: (values: string[]) => void;
  disabled?: boolean;
};

export function CheckboxGroup({
  options,
  selectedValues,
  onValueChange,
  disabled = false,
}: Props) {
  const handleToggle = (value: string) => {
    if (disabled) return;

    const isSelected = selectedValues.includes(value);
    const newValues = isSelected
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];

    onValueChange(newValues);
  };

  return (
    <View style={styles.container}>
      {options.map((option) => {
        const isChecked = selectedValues.includes(option.value);

        return (
          <TouchableOpacity
            key={option.value}
            style={styles.checkboxItem}
            onPress={() => handleToggle(option.value)}
            disabled={disabled}
            activeOpacity={0.7}
          >
            <PaperCheckbox.Android
              status={isChecked ? 'checked' : 'unchecked'}
              color={Colors.purple1}
              uncheckedColor={Colors.opacity40}
              disabled={disabled}
            />
            <TextReg
              style={[
                styles.label,
                isChecked && styles.selectedLabel,
                disabled && styles.disabledLabel,
              ]}
            >
              {option.label}
            </TextReg>
          </TouchableOpacity>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: 8,
  },
  checkboxItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  label: {
    fontSize: 14,
    color: Colors.text,
    opacity: 0.8,
  },
  selectedLabel: {
    opacity: 1,
    fontWeight: '600',
    color: Colors.purple1,
  },
  disabledLabel: {
    opacity: 0.4,
  },
});
